var render = function render(){var _vm=this,_c=_vm._self._c;return _c('erp-select',{attrs:{"multiple":"","placeholder":"Todos","options":_vm.sitesFiltered,"loading":_vm.loading,"size":"2"},on:{"input":(v) => _vm.$emit('input', v)},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }